import React, { useRef, useEffect, useState } from 'react';
import { getKvizPitanje } from '../../server/server-kviz';
import Footer from './Footer';
import { ReactComponent as PuskicaLogoSarena } from '../../assets/svg/PuskicaLogoSarena.svg';
import { useNavigate } from 'react-router-dom';
import '../../style/lekcija.css';
import AdSlot from '../common/AdSlot';

function Home() {
    const navigate = useNavigate();
    return (
        <div className="relative z-0 overflow-y-auto bg-blueDark no-scroll w-full h-full">
            <div className="fixed inset-0 pointer-events-none flex items-center justify-center -z-10">
                <PuskicaLogoSarena className="w-full h-full opacity-30" />
            </div>
            <div className="flex flex-col items-center  py-10 ">
                <div className="w-full max-w-[1200px] flex flex-col items-center px-5">
                    <p className="text-white text-[22px] leading-7 font-semibold">
                        Puskica-kviz je edukativna platforma koja kroz strukturisane oblasti u formi “knjiga” sa lekcijama, skriptama, testovima, pitanjima i
                        interaktivnim kvizovima omogućava korisnicima svih uzrasta da uče, vežbaju i prate svoj napredak na jednom mestu.
                    </p>
                    <div className="bg-blueLight flex flex-col lg:flex-row gap-5 rounded-[30px] p-4 lg:p-6 mt-7 lg:mt-10">
                        <div>
                            <p className="text-white text-[16px] lg:text-[30px] leading-5 lg:leading-9 font-bold">
                                Testovi za upis u srednju školu su pripremni testovi koji imaju za cilj da pomognu učenicima da se pripreme za polaganje
                                prijemnih ispita za upis u srednju školu, pružajući im priliku da vežbaju i unaprede svoje znanje iz različitih predmeta, kao
                                što su matematika, srpski jezik, georafija, biologija, istorija i drugi.
                            </p>
                        </div>
                        <button onClick={() => navigate('/user/oblast/54ba3d07-da2b-44b9-a734-a8c835cae69b')} className="start-button-new">
                            <p className="text-white text-[16px] lg:text-[24px] leading-5 lg:leading-9 font-bold ">Pogledaj testove</p>
                        </button>
                    </div>
                    <div className="bg-blueLight flex flex-col lg:flex-row gap-5 rounded-[30px] p-4 lg:p-6 mt-7 lg:mt-10">
                        <div>
                            <p className="text-white text-[16px] lg:text-[30px] leading-5 lg:leading-9 font-bold">
                                Testiraj svoje znanje o automobilima i otkrij da li bi mogao da se snađeš kao pravi majstor ispod haube.
                            </p>
                        </div>
                        <button onClick={() => navigate('/user/oblast/6721c005-fe63-4dd7-ae82-1a31986495ec')} className="start-button-new">
                            <p className="text-white text-[16px] lg:text-[24px] leading-5 lg:leading-9 font-bold">Pogledaj testove</p>
                        </button>
                    </div>
                    <AdSlot placement="home" />
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default Home;
